import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './PageLoader.css';

// Évite le flash de l'overlay plein écran quand le chargement est instantané
// (ex: chunk déjà en cache navigateur) — ne s'affiche que si l'attente dépasse `delay`.
export function DelayedPageLoader({ text, delay = 200 }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(id);
  }, [delay]);

  if (!show) return null;
  return <PageLoader text={text} />;
}

export default function PageLoader({ text }) {
  const { t } = useTranslation();
  return (
    <div className="pl-overlay">
      <div className="pl-box">

        <div className="pl-brand">
          <div className="pl-brand__name">
            Auto<span>Market</span>
          </div>
          <div className="pl-brand__tagline">{t('marketplaceTagline')}</div>
        </div>

        <div className="pl-spinner-wrap">
          <div className="pl-spinner-outer" />
          <div className="pl-spinner-inner" />
        </div>

        <div className="pl-progress">
          <div className="pl-progress__bar" />
        </div>

        <p className="pl-text">{text || t('loading')}</p>

      </div>
    </div>
  );
}
